<template>
  <div id="grupoProdutosId">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="produtoFilter"
                :items="filterProduto.length > 0 ? filterProduto : produtoOptions"
                label="Filtrar por Produto"
                multiple
                outlined
                dense
                clearable
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-action>
                      <input
                        id="filtroProduto"
                        v-model="filtroProdutos"
                        prepend-inner-icon="mdi-account-search"
                        placeholder="Filtrar Produtos"
                        @change="filterProdutosToggle"
                      >
                    </v-list-item-action>
                    <v-divider class="mt-2" /><br>
                  </v-list-item>
                  <v-list-item
                    slot="prepend-item"
                    ripple
                    @click="toggleProdutos"
                  >
                    <v-list-item-action>
                      <v-icon :color="produtoOptions.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconProdutos }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-title id="idSelecTotos">
                      Selecionar todos
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-select>
            </v-col>
            <v-col
              v-if="!enableBtn"
              cols="12"
              md="3"
            >
              <v-btn
                id="btnPrint"
                class="mr-2"
                small
                dark
                :color="corPrimaria"
                :disabled="enableBtn"
                :loading="imprimindo"
                @click="exportPDF()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Exporta PDF
                <template v-slot:loader>
                  <span>Gerando...</span>
                </template>
              </v-btn>
            </v-col>
            <v-col
              v-if="!enableBtn"
              cols="12"
              md="3"
            >
              <v-btn
                id="btnPrint"
                class="mr-2"
                small
                dark
                :color="corPrimaria"
                :disabled="enableBtn"
                :loading="imprimindoExcel"
                @click="exportExcel()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Exporta Excel
                <template v-slot:loader>
                  <span>Gerando...</span>
                </template>
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <div
                id="idTable"
                style="overflow-x: auto;"
              >
                <table
                  style="width: 100%; color: black; border-collapse: collapse;"
                  class="elevation-1"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      />
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Produto
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Soma Variação Volume
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center;"
                      >
                        Soma Variação Preço Médio
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(item, index) in (filteredItems.length > 0 ? filteredItems : variacaoVolumePrecoMedio)"
                    :key="item.id"
                  >
                    <!-- Linha principal -->
                    <tr>
                      <td style="text-align: center;">
                        <button @click="toggleExpand(index)">
                          {{ expanded.includes(index) ? '▲' : '▼' }}
                        </button>
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ item.produto }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ item.volume }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ item.precoMedio }}
                      </td>
                    </tr>
                    <!-- Linha expandida -->
                    <tr
                      v-if="expanded.includes(index)"
                      :key="'expanded-' + item.id"
                    >
                      <td colspan="4">
                        <table
                          id="tableExpandida"
                          style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center"
                              >
                                Mês
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                              >
                                Soma Variação Volume
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;"
                              >
                                Soma Variação Preço Médio
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(sub, idx) in item.dadosProdutos"
                              :key="idx"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center;"
                              >
                                {{ sub.mes }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right;"
                              >
                                {{ sub.volume }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right;"
                              >
                                {{ sub.precoMedio }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
        >
          <canvas
            id="analiseVolumePrecoMedio"
            width="30"
            height="10"
          />
          <div
            v-if="exibirLegenda"
            id="legendaAnaliseFaturamentoVolume"
            class="text-center px-3"
          >
            <v-row
              align="center"
              class="text-center ma-0"
            >
              <v-avatar
                class="text-center mr-1"
                color="#4780b8"
                size="10"
              />
              <span class="text-center mr-3 font-weight-light">Preço Médio</span>
              <v-avatar
                class="text-center mr-1"
                color="#FDD835"
                size="10"
              />
              <span class="text-center mr-3 font-weight-light">Volume</span>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>
<script>
  import AnaliseFaturamento from '../../../../../services/analisefaturamento'
  import eventEmit from '../../core/EventoEmit'
  import Chart from 'chart.js'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'
  import ExcelJS from 'exceljs'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ShowFaturamentoVendas',
    emits: ['dadosMargemTotal'],
    components: {
      DashboardCoreSnackbar: () => import('../../core/Snackbar'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: '#2863af',
      loading: false,
      error: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      cidades: [],
      areas: [],
      supervisores: [],
      vendedores: [],
      redes: [],
      headersVariacaoVolumePrecoMedio: [
        { text: 'Produto', value: 'produto', class: 'black--text title' },
        { text: 'Soma Variação Volume', value: 'volume', align: 'right', class: 'black--text title' },
        { text: 'Soma Variação Preço Médio', value: 'precoMedio', align: 'right', class: 'black--text title' },
      ],
      headersFaturamentoVolume: [
        { text: 'Mês', value: 'mes', width: '40%', class: 'black--text title' },
        { text: 'Soma Variação Volume', value: 'volume', width: '30%', align: 'right', class: 'black--text title' },
        { text: 'Soma Variação Preço Médio', value: 'precoMedio', align: 'right', width: '30%', class: 'black--text title' },
      ],
      variacaoVolumePrecoMedio: [],
      filtroProdutos: '',
      filterProduto: [],
      produtoFilter: [],
      expanded: [],
      label: [],
      precoMedio: [],
      volume: [],
      labelFiltrado: [],
      precoMedioFiltrado: [],
      volumeFiltrado: [],
      myChart: {},
      enableGrafico: false,
      exibirLegenda: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableBtn: true,
      imprimindo: false,
      imprimindoExcel: false,
    }),

    computed: {
      produtoOptions () {
        return [...new Set(this.variacaoVolumePrecoMedio.map(item => item.produto))]
      },

      filteredItems () {
        return this.variacaoVolumePrecoMedio.filter(item => {
          const produtoMatch = this.produtoFilter.length === 0 || this.produtoFilter.includes(item.produto)

          return produtoMatch
        })
      },

      likesAllProdutos () {
        const baseProduto =
          this.filterProduto.length > 0
            ? this.filterProduto
            : this.produtoOptions

        return this.produtoFilter.length === baseProduto.length
      },

      likesSomeProdutos () {
        return this.produtoFilter.length > 0 && !this.likesAllProdutos
      },

      iconProdutos () {
        if (this.likesAllProdutos) return 'mdi-close-box'
        if (this.likesSomeProdutos) return 'mdi-minus-box'

        return 'mdi-checkbox-blank-outline'
      },
    },

    watch: {
      produtoFilter: {
        handler () {
          this.atualizarDadosGrafico()
        },
        deep: true,
      },
    },

    created () {
      eventEmit.$on('update-form-analise-faturamento-mais-vida', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-analise-faturamento-mais-vida', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresa, cidades, areas, supervisores, vendedores, redes) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresa = empresa
        this.cidades = cidades
        this.areas = areas
        this.supervisores = supervisores
        this.vendedores = vendedores
        this.redes = redes

        this.showAnaliseVariacaoVolumePrecoMedio()
      },

      toggleProdutos () {
        this.$nextTick(() => {
          if (this.likesAllProdutos) {
            this.produtoFilter = []
          } else {
            const baseProduto =
              this.filterProduto.length > 0
                ? this.filterProduto
                : this.produtoOptions

            this.produtoFilter = [...baseProduto]
          }
        })
      },

      filterProdutosToggle () {
        this.produtoFilter = []

        if (this.filtroProdutos.length > 0) {
          const baseProduto =
            this.filterProduto.length > 0
              ? this.filterProduto
              : this.produtoOptions

          this.produtoFilter = baseProduto.filter(produto =>
            produto.toLowerCase().includes(this.filtroProdutos.toLowerCase()),
          )
        }
      },

      async showAnaliseVariacaoVolumePrecoMedio () {
        this.loading = true

        this.variacaoVolumePrecoMedio = []

        this.expanded = []

        this.exibirLegenda = false

        this.enableBtn = true

        AnaliseFaturamento.showDadosAnaliseVariacaoVolumePrecoMedio(this.dataInicial, this.dataFinal, this.empresa, this.cidades, this.areas, this.supervisores, this.vendedores, this.redes, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.variacaoVolumePrecoMedio = resposta.data.dadosExibicao.map((item) => {
              var lista = ({
                produto: item.produto,
                volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                precoMedio: 'R$' + parseFloat(item.precoMedio).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }),
                icone: item.icone,
                expandir: item.expandir,
                dadosProdutos: this.getDadosMensais(item.dadosProdutos),
              })

              return lista
            })

            this.label = resposta.data.label
            this.precoMedio = resposta.data.precoMedio
            this.volume = resposta.data.volume

            this.enableGrafico = true

            this.enableBtn = false
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => {
          this.loading = false

          this.$nextTick(() => {
            this.montarGrafico()

            this.exibirLegenda = true
          })
        })
      },

      getDadosMensais (value) {
        const dadosProdutos = value.map((item) => {
          var lista = ({
            mes: item.mes,
            volume: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            volumeAux: parseFloat(item.volume),
            precoMedio: 'R$' + parseFloat(item.precoMedio).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }),
            precoMedioAux: parseFloat(item.precoMedio),
          })

          return lista
        })

        return dadosProdutos
      },

      atualizarDadosGrafico () {
        if (this.filteredItems.length > 0) {
          this.labelFiltrado = []
          this.precoMedioFiltrado = []
          this.volumeFiltrado = []

          const agrupados = {}

          const labelsSet = new Set()

          this.filteredItems.forEach((produto) => {
            produto.dadosProdutos.forEach((detalhe) => {
              const data = detalhe.mes

              if (!agrupados[data]) {
                agrupados[data] = {
                  volume: 0,
                  precoMedio: 0,
                }
              }

              labelsSet.add(data)

              agrupados[data].precoMedio += detalhe.precoMedioAux

              agrupados[data].volume += detalhe.volumeAux
            })
          })

          this.labelFiltrado = Array.from(labelsSet)

          this.precoMedioFiltrado = Object.keys(agrupados).map((data) => agrupados[data].precoMedio)

          this.volumeFiltrado = Object.keys(agrupados).map((data) => agrupados[data].volume)

          this.montarGrafico()
        } else {
          this.labelFiltrado = []
          this.precoMedioFiltrado = []
          this.volumeFiltrado = []

          this.montarGrafico()
        }
      },

      montarGrafico () {
        try {
          if (this.myChart?.data) {
            this.myChart.destroy()
          }

          const ctx = document.getElementById('analiseVolumePrecoMedio').getContext('2d')

          this.myChart = new Chart(ctx, {
            type: 'line',
            data: {
              labels: this.labelFiltrado.length > 0 ? this.labelFiltrado : this.label,
              datasets: [
                {
                  label: 'Variação Preco Médio',
                  data: this.precoMedioFiltrado.length > 0 ? this.precoMedioFiltrado : this.precoMedio,
                  borderColor: '#4780b8',
                  backgroundColor: 'transparent',
                  order: 1,
                  fill: false,
                  tension: 0,
                },
                {
                  label: 'Variação Volume',
                  data: this.volumeFiltrado.length > 0 ? this.volumeFiltrado : this.volume,
                  borderColor: '#FDD835',
                  backgroundColor: 'transparent',
                  order: 1,
                  fill: false,
                  tension: 0,
                },
              ],
            },
            options: {
              scales: {
                y: {
                  beginAtZero: true,
                },
                xAxes: [{
                  gridLines: {
                    display: false,
                  },
                }],
                yAxes: [{
                  gridLines: {
                    display: false,
                  },
                  display: false,
                }],
              },
              low: 10,
              high: 5,
              legend: {
                display: false,
              },
              tooltips: {
                callbacks: {
                  label: (tooltipItem, data) => {
                    if (tooltipItem.datasetIndex === 0) {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    } else if (tooltipItem.datasetIndex === 1) {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    }
                  },
                },
              },
            },
          })
        } catch (error) {
          console.error(error)
        }
      },

      async exportPDF () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar pdf', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')
          let posYFiltros = 10

          const filtro = 'Filtros selecionados'
          pdf.text(filtro, 105, posYFiltros)

          const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
          const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisores.map(v => v.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))

          if (posYFiltros > 150) {
            pdf.addPage()
            posYFiltros = 10
          }

          posYFiltros += 5

          let previousTableY = posYFiltros

          const dados = this.filteredItems.length > 0 ? this.filteredItems : this.variacaoVolumePrecoMedio

          dados.forEach((row, index) => {
            const dadosTabelaPrincipal = [
              [row.produto, row.volume, row.precoMedio],
            ]

            const tablePrincipal = pdf.autoTable({
              head: [this.headersVariacaoVolumePrecoMedio.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: dadosTabelaPrincipal.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 0
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'left' : 'right',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 10 },
              columnStyles: {
                0: { cellWidth: 150 },
                1: { cellWidth: 50 },
                2: { cellWidth: 50 },
              },
            })

            previousTableY = tablePrincipal.lastAutoTable.finalY

            const dadosDetalhesProdutos = row.dadosProdutos.map(item => [item.mes, item.volume, item.precoMedio])

            const tableDetalhes = pdf.autoTable({
              head: [this.headersFaturamentoVolume.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: dadosDetalhesProdutos.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 0
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'left' : 'right',
                  },
                }
              })),
              startY: previousTableY,
              styles: { fontSize: 10 },
              columnStyles: {
                0: { cellWidth: 150 },
                1: { cellWidth: 50 },
                2: { cellWidth: 50 },
              },
            })

            previousTableY = tableDetalhes.lastAutoTable.finalY + 10
          })

          pdf.save('relatorio_volume_preco_medio.pdf')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindo = false
        }
      },

      async exportExcel () {
        try {
          this.imprimindoExcel = true

          await setTimeout(() => {
            this.printExcel()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar excel', error)
        }
      },

      async printExcel () {
        try {
          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet('Relatório Analise Faturamento Volume')

          let posY = 1

          const inserirTitulo = (worksheet) => {
            // Adicionar Título
            worksheet.mergeCells(`A${posY}:F${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Filtros selecionados'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
            const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)

            worksheet.mergeCells(`A${posY}:F${posY}`)
            worksheet.getCell(`A${posY}`).value = `Data inicial: ${dataInicial} - Data final: ${ultimoDia}`
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const adicionarFiltros = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.mergeCells(`A${posY}:F${posY}`)
                worksheet.getCell(`A${posY}`).value = texto
                worksheet.getCell(`A${posY}`).font = { size: 10 }
                worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            posY = adicionarFiltros(worksheet, posY, 'Empresa(s) Selecionada(s):', this.empresa.map(e => e.nome))
            posY = adicionarFiltros(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.supervisores.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
            posY = adicionarFiltros(worksheet, posY, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))

            worksheet.addRow([])
            posY += 1
          }

          posY += 1

          inserirTitulo(worksheet)

          const dados = this.filteredItems.length > 0 ? this.filteredItems : this.variacaoVolumePrecoMedio

          dados.forEach(produto => {
            // Adicionar linha do cliente
            posY += 2
            worksheet.addRow(['Produto: ' + produto.produto, 'Variação Volume: ' + produto.volume, 'Variação Preço Médio: ' + produto.precoMedio]).font = { bold: true }
            posY += 1

            // Adicionar cabeçalhos dos produtos
            const headers = ['Mês', 'Variação Volume', 'Variação Preço Médio']
            worksheet.addRow(headers).font = { bold: true }
            posY += 1

            // Adicionar produtos do cliente
            produto.dadosProdutos.forEach(p => {
              worksheet.addRow([p.mes, p.volume, p.precoMedio])
              posY += 1
            })

            posY += 3 // Espaçamento entre grupos
            // Adiciona uma linha em branco antes do próximo cliente
            worksheet.addRow([])
            posY += 1
          })

          // Ajustar larguras de coluna automaticamente
          worksheet.columns.forEach(column => {
            let maxLength = 0
            column.eachCell({ includeEmpty: true }, cell => {
              if (cell.value) {
                maxLength = Math.max(maxLength, cell.value.toString().length)
              }
            })
            column.width = maxLength + 2 // +2 para espaçamento
          })

          const buffer = await workbook.xlsx.writeBuffer()
          saveAs(new Blob([buffer]), 'relatorio_variacao_volume_preco_medio.xlsx')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindoExcel = false
        }
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 401px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  .v-data-table__wrapper {
    overflow-x: auto;
  }

  #analiseVolumePrecoMedio {
    margin: 8rem 0 0 0
  }

  #legendaAnaliseFaturamentoVolume {
    margin: 2rem 0 0 0rem
  }
</style>
